import React, { useState, useEffect, useRef } from 'react';
import { useIntl, getLocale } from 'umi';
import { Table } from 'tea-component';
const { pageable } = Table.addons;

import {
  formatNum,
  formatPercentNum,
} from '@/pages/intelligence/utils/commonUtils';
import defaltCountryImg from '@/pages/home/assets/img/flag/default.svg';
import { MARKETBIGRISERGAMESTIP } from '@/pages/intelligence/pages/MarketProfile/_config/Const';
import Loading from '@/pages/intelligence/components/Loading';
import NoData from '@/pages/intelligence/components/NoData';
import CardSlot from '@/pages/intelligence/components/CardSlot';
import TipContext from '@/pages/home/components/TipContextComponents/TipContext';
import xbox from '@/pages/intelligence/assets/svg/marketprofile/xbox.svg';
import playstation from '@/pages/intelligence/assets/svg/marketprofile/playstation.svg';
import nintendo from '@/pages/intelligence/assets/svg/marketprofile/nintendo.svg';

import appstore from '@/pages/intelligence/assets/svg/dataSource/appstore.svg';
import mscience32 from '@/pages/intelligence/assets/svg/marketprofile/mscience32.svg';
import newzoonew from '@/pages/home/assets/svg/dataSource/databarin.svg';
// import newzoonew from '@/pages/intelligence/assets/svg/marketprofile/newzoonew.svg';

import Steam from '@/pages/intelligence/assets/svg/marketprofile/Steam.svg';
import Epic from '@/pages/intelligence/assets/svg/marketprofile/Epic.svg';
import PS4 from '@/pages/intelligence/assets/svg/marketprofile/PS4.svg';
import SortBy from '@/pages/intelligence/components/TableComponents/components/SortBy';
import FirstRow from '@/pages/intelligence/components/TableComponents/components/FirstRow';
import TableShowData from '@/pages/intelligence/components/TableComponents/components/TableShowData';
import TabComponents from '@/pages/intelligence/components/TabComponents';
import { dbiBtnLogMes } from '@/pages/intelligence/utils/buriedPointCfg';
import CloumsCenter from '@/pages/intelligence/components/TableComponents/components/CloumsCenter';

export default function BigRiserGameList(props: any) {
  /**
   * title ： 标题栏标题
   * time ： 标题栏时间
   * data ： 展示的数据
   * gameType ： 游戏类型对应不同的展示内容，mobile、pc、console、company
   * icon ： 表格表头的revenue图标
   * needTitle ： 是否需要标题栏
   */
  const {
    title,
    data,
    time,
    gameType,
    riserLoad,
    gotoGameDetailsPage,
    needTitle,
  } = props;
  const [tableColumn, setTableColumn] = useState([]);
  const { scrollable } = Table.addons;
  const { formatMessage } = useIntl();
  const locale = getLocale();
  useEffect(() => {
    getColumns();
  }, [gameType, locale]);

  const getColumns = () => {
    let columns = [] as any;
    if (gameType == 'mobile') {
      columns = [
        {
          key: 'name',
          header: formatMessage({ id: 'dbi_game' }),
          fixed: 'left',
          width: 300,
          render: (cvm: any) => (
            <FirstRow
              cvm={{
                imgType: gameType,
                gametitle: cvm.name,
                img: cvm.gameIcon,
                countryIcon: cvm['conutryFlag'] || defaltCountryImg,
                text: cvm['desc'],
              }}
              onClick={() =>
                gotoGameDetailsPage(cvm, {
                  ...dbiBtnLogMes.marketProfileInsightsClickGame,
                  extInfo: 'Big Riser',
                })
              }
              rihgtClickToJumpHref={gotoGameDetailsPage(
                cvm,
                {
                  ...dbiBtnLogMes.marketProfileInsightsClickGame,
                  extInfo: 'Big Riser',
                },
                false,
              )}
            />
          ),
        },
        {
          key: 'top_free',
          align: 'center',
          header: (
            <CloumsCenter
              width={160}
              style={{ marginLeft: '-40px' }}
              align="right"
            >
              <SortBy
                title={formatMessage({ id: 'dbi_store_rank_top_free' })}
                isNoDropdown={true}
                svgIcon={appstore}
              />
            </CloumsCenter>
          ),
          width: 260,
          render: (cvm: any) => (
            <div className="">
              <CloumsCenter
                width={160}
                style={{ marginLeft: '-40px' }}
                align="right"
              >
                <TableShowData
                  type={
                    cvm['top_free_change'] > 0
                      ? 'up'
                      : cvm['top_free_change'] < 0
                      ? 'down'
                      : ''
                  }
                  growth={
                    cvm['top_free_change'] == 0
                      ? '-'
                      : Math.abs(cvm['top_free_change'])
                  }
                  value={cvm['top_free'] != 0 ? '#' + cvm['top_free'] : '-'}
                />
              </CloumsCenter>

              {cvm['topFreeTips']?.length > 0
                ? cvm['topFreeTips']?.map((obj: any) => {
                    return <TabComponents data={RanderTipsData(obj)} />;
                  })
                : null}
            </div>
          ),
        },
        {
          key: 'top_grossing',
          align: 'center',
          header: (
            <CloumsCenter
              width={160}
              style={{ marginLeft: '-40px' }}
              align="right"
            >
              <SortBy
                title={formatMessage({ id: 'dbi_store_rank_top_grossing' })}
                isNoDropdown={true}
                svgIcon={appstore}
              />
            </CloumsCenter>
          ),
          width: 260,
          render: (cvm: any) => (
            <div className="">
              <CloumsCenter
                width={160}
                style={{ marginLeft: '-40px' }}
                align="right"
              >
                <TableShowData
                  type={
                    cvm['top_grossing_change'] > 0
                      ? 'up'
                      : cvm['top_grossing_change'] < 0
                      ? 'down'
                      : ''
                  }
                  growth={
                    cvm['top_grossing_change'] == 0
                      ? '-'
                      : Math.abs(cvm['top_grossing_change'])
                  }
                  value={
                    cvm['top_grossing'] != 0 ? '#' + cvm['top_grossing'] : '-'
                  }
                />
              </CloumsCenter>
              {cvm['topGrossingTips']?.length > 0
                ? cvm['topGrossingTips']?.map((obj: any) => {
                    return <TabComponents data={RanderTipsData(obj)} />;
                  })
                : null}
            </div>
          ),
        },
        {
          key: 'top_paid',
          align: 'center',
          header: (
            <CloumsCenter
              width={160}
              style={{ marginLeft: '-40px' }}
              align="right"
            >
              <SortBy
                title={formatMessage({ id: 'dbi_store_rank_top_paid' })}
                isNoDropdown={true}
                svgIcon={appstore}
              />
            </CloumsCenter>
          ),
          width: 260,
          render: (cvm: any) => (
            <div className="">
              <CloumsCenter
                width={160}
                style={{ marginLeft: '-40px' }}
                align="right"
              >
                <TableShowData
                  type={
                    cvm['top_paid_change'] > 0
                      ? 'up'
                      : cvm['top_paid_change'] < 0
                      ? 'down'
                      : ''
                  }
                  growth={
                    cvm['top_paid_change'] == 0
                      ? '-'
                      : Math.abs(cvm['top_paid_change'])
                  }
                  value={cvm['top_paid'] != 0 ? '#' + cvm['top_paid'] : '-'}
                />
              </CloumsCenter>
              {cvm['topPaidTips']?.length > 0
                ? cvm['topPaidTips']?.map((obj: any) => {
                    return <TabComponents data={RanderTipsData(obj)} />;
                  })
                : null}
            </div>
          ),
        },
      ];
    } else if (gameType == 'pc') {
      columns = [
        {
          key: 'name',
          header: formatMessage({ id: 'dbi_game' }),
          width: 300,
          fixed: 'left',
          render: (cvm: any) => (
            <FirstRow
              cvm={{
                imgType: gameType,
                gametitle: cvm.name,
                img: cvm.gameIcon,
                countryIcon: cvm['conutryFlag'] || defaltCountryImg,
                text: cvm['desc'],
              }}
              onClick={() =>
                gotoGameDetailsPage(cvm, {
                  ...dbiBtnLogMes.marketProfileInsightsClickGame,
                  extInfo: 'Big Riser',
                })
              }
              rihgtClickToJumpHref={gotoGameDetailsPage(
                cvm,
                {
                  ...dbiBtnLogMes.marketProfileInsightsClickGame,
                  extInfo: 'Big Riser',
                },
                false,
              )}
            />
          ),
        },
        {
          key: 'mscience',
          align: 'center',
          header: (
            <CloumsCenter
              width={200}
              style={{ marginLeft: '-40px' }}
              align="right"
            >
              <SortBy
                title={formatMessage({ id: 'dbi_metric_digitalRevenue' })}
                isNoDropdown={true}
                svgIcon={mscience32}
              />
            </CloumsCenter>
          ),
          width: 350,
          render: (cvm: any) => (
            <div className="">
              <CloumsCenter
                width={200}
                style={{ marginLeft: '-40px' }}
                align="right"
              >
                <TableShowData
                  type={
                    cvm['mscienceChange'] > 0
                      ? 'up'
                      : cvm['mscienceChange'] < 0
                      ? 'down'
                      : ''
                  }
                  growth={
                    cvm['mscienceChange'] == 0
                      ? '—'
                      : formatPercentNum(cvm['mscienceChange'])
                  }
                  value={
                    cvm['mscience'] != 0 ? formatNum(cvm['mscience']) : '-'
                  }
                />
              </CloumsCenter>

              {cvm['msRevenueTips']?.length > 0
                ? cvm['msRevenueTips']?.map((obj: any) => {
                    return <TabComponents data={RanderTipsData(obj)} />;
                  })
                : null}
            </div>
          ),
        },
        {
          key: 'newzoo',
          align: 'center',
          header: (
            <CloumsCenter
              width={210}
              style={{ marginLeft: '-40px' }}
              align="right"
            >
              <SortBy
                title={`${formatMessage({ id: 'dbi_mau' })}`}
                isNoDropdown={true}
                svgIcon={newzoonew}
              />
            </CloumsCenter>
          ),
          width: 350,
          render: (cvm: any) => (
            <div className="">
              <CloumsCenter
                width={200}
                style={{ marginLeft: '-40px' }}
                align="right"
              >
                <TableShowData
                  type={
                    cvm['newzooChange'] > 0
                      ? 'up'
                      : cvm['newzooChange'] < 0
                      ? 'down'
                      : ''
                  }
                  growth={
                    cvm['newzooChange'] == 0
                      ? '-'
                      : formatPercentNum(cvm['newzooChange'])
                  }
                  value={cvm['newzoo'] != 0 ? formatNum(cvm['newzoo']) : '-'}
                />
              </CloumsCenter>

              {cvm['newzooTips']?.length > 0
                ? cvm['newzooTips']?.map((obj: any) => {
                    return <TabComponents data={RanderTipsData(obj)} />;
                  })
                : null}
            </div>
          ),
        },
        {
          key: 'trending',
          align: 'center',
          header: (
            <CloumsCenter
              width={200}
              style={{ marginLeft: '-40px' }}
              align="right"
            >
              <SortBy
                title={'New&Trending'}
                isNoDropdown={true}
                svgIcon={Steam}
              />
            </CloumsCenter>
          ),
          width: 350,
          render: (cvm: any) => (
            <div className="">
              <CloumsCenter
                width={200}
                style={{ marginLeft: '-40px' }}
                align="right"
              >
                <TableShowData
                  type={
                    cvm['trendingChange'] > 0
                      ? 'up'
                      : cvm['trendingChange'] < 0
                      ? 'down'
                      : ''
                  }
                  growth={
                    cvm['trendingChange'] == 0
                      ? '-'
                      : Math.abs(cvm['trendingChange'])
                  }
                  value={cvm['trending'] != 0 ? '#' + cvm['trending'] : '-'}
                />
              </CloumsCenter>

              {cvm['trendingTips']?.length > 0
                ? cvm['trendingTips']?.map((obj: any) => {
                    return <TabComponents data={RanderTipsData(obj)} />;
                  })
                : null}
            </div>
          ),
        },
        {
          key: 'sellers',
          align: 'center',
          header: (
            <CloumsCenter
              width={200}
              style={{ marginLeft: '-40px' }}
              align="right"
            >
              <SortBy
                title={'Steam Top Sellers'}
                isNoDropdown={true}
                svgIcon={Steam}
              />
            </CloumsCenter>
          ),
          width: 350,
          render: (cvm: any) => (
            <div className="">
              <CloumsCenter
                width={200}
                style={{ marginLeft: '-40px' }}
                align="right"
              >
                <TableShowData
                  type={
                    cvm['sellersChange'] > 0
                      ? 'up'
                      : cvm['sellersChange'] < 0
                      ? 'down'
                      : ''
                  }
                  growth={
                    cvm['sellersChange'] == 0
                      ? '-'
                      : Math.abs(cvm['sellersChange'])
                  }
                  value={cvm['sellers'] != 0 ? '#' + cvm['sellers'] : '-'}
                />
              </CloumsCenter>

              {cvm['sellerTips']?.length > 0
                ? cvm['sellerTips']?.map((obj: any) => {
                    return <TabComponents data={RanderTipsData(obj)} />;
                  })
                : null}
            </div>
          ),
        },
        {
          key: 'popular',
          align: 'center',
          header: (
            <CloumsCenter
              width={200}
              style={{ marginLeft: '-40px' }}
              align="right"
            >
              <SortBy
                title={'Epic Top Pupolar'}
                isNoDropdown={true}
                svgIcon={Epic}
              />
            </CloumsCenter>
          ),
          width: 350,
          render: (cvm: any) => (
            <div className="">
              <CloumsCenter
                width={200}
                style={{ marginLeft: '-40px' }}
                align="right"
              >
                <TableShowData
                  type={
                    cvm['popularChange'] > 0
                      ? 'up'
                      : cvm['popularChange'] < 0
                      ? 'down'
                      : ''
                  }
                  growth={
                    cvm['popularChange'] == 0
                      ? '-'
                      : Math.abs(cvm['popularChange'])
                  }
                  value={cvm['popular'] != 0 ? '#' + cvm['popular'] : '-'}
                />
              </CloumsCenter>

              {cvm['epicTips']?.length > 0
                ? cvm['epicTips']?.map((obj: any) => {
                    return <TabComponents data={RanderTipsData(obj)} />;
                  })
                : null}
            </div>
          ),
        },
      ];
    } else if (gameType == 'console') {
      columns = [
        {
          key: 'name',
          header: formatMessage({ id: 'dbi_game' }),
          width: 400,
          fixed: 'left',
          render: (cvm: any) => (
            <FirstRow
              cvm={{
                imgType: gameType,
                gametitle: cvm.name,
                img: cvm.gameIcon,
                countryIcon: cvm['conutryFlag'] || defaltCountryImg,
                text: cvm['desc'],
                icon: cvm['platList']?.map((obj: string) => {
                  if (obj.toUpperCase() == 'PS') return playstation;
                  else if (obj.toUpperCase() == 'XBOX') return xbox;
                  else if (obj.toUpperCase() == 'NINTENDO') return nintendo;
                  else {
                    return '';
                  }
                }),
              }}
              onClick={() =>
                gotoGameDetailsPage(cvm, {
                  ...dbiBtnLogMes.marketProfileInsightsClickGame,
                  extInfo: 'Big Riser',
                })
              }
              rihgtClickToJumpHref={gotoGameDetailsPage(
                cvm,
                {
                  ...dbiBtnLogMes.marketProfileInsightsClickGame,
                  extInfo: 'Big Riser',
                },
                false,
              )}
            />
          ),
        },
        {
          key: 'psSelling',
          align: 'center',
          header: (
            <CloumsCenter
              width={160}
              style={{ marginLeft: '-40px' }}
              align="right"
            >
              <SortBy
                title={formatMessage({ id: 'dbi_store_rank_best_selling' })}
                isNoDropdown={true}
                svgIcon={PS4}
              />
            </CloumsCenter>
          ),
          width: 300,
          render: (cvm: any) => (
            <div className="">
              <CloumsCenter
                width={160}
                style={{ marginLeft: '-40px' }}
                align="right"
              >
                <TableShowData
                  type={
                    cvm['psSellingChange'] > 0
                      ? 'up'
                      : cvm['psSellingChange'] < 0
                      ? 'down'
                      : ''
                  }
                  growth={
                    cvm['psSellingChange'] == 0
                      ? '-'
                      : Math.abs(cvm['psSellingChange'])
                  }
                  value={cvm['psSelling'] != 0 ? '#' + cvm['psSelling'] : '-'}
                />
              </CloumsCenter>

              {cvm['psSellingTips']?.length > 0
                ? cvm['psSellingTips']?.map((obj: any) => {
                    return <TabComponents data={RanderTipsData(obj)} />;
                  })
                : null}
            </div>
          ),
        },
        {
          key: 'psDownload',
          align: 'center',
          header: (
            <CloumsCenter
              width={180}
              style={{ marginLeft: '-40px' }}
              align="right"
            >
              <SortBy
                title={formatMessage({ id: 'dbi_store_rank_most_downloaded' })}
                isNoDropdown={true}
                svgIcon={PS4}
              />
            </CloumsCenter>
          ),
          width: 300,
          render: (cvm: any) => (
            <div className="">
              <CloumsCenter
                width={160}
                style={{ marginLeft: '-40px' }}
                align="right"
              >
                <TableShowData
                  type={
                    cvm['psDownloadChange'] > 0
                      ? 'up'
                      : cvm['psDownloadChange'] < 0
                      ? 'down'
                      : ''
                  }
                  growth={
                    cvm['psDownloadChange'] == 0
                      ? '-'
                      : Math.abs(cvm['psDownloadChange'])
                  }
                  value={cvm['psDownload'] != 0 ? '#' + cvm['psDownload'] : '-'}
                />
              </CloumsCenter>

              {cvm['psDownloadTips']?.length > 0
                ? cvm['psDownloadTips']?.map((obj: any) => {
                    return <TabComponents data={RanderTipsData(obj)} />;
                  })
                : null}
            </div>
          ),
        },
        {
          key: 'xboxPlay',
          align: 'center',
          header: (
            <CloumsCenter
              width={160}
              style={{ marginLeft: '-40px' }}
              align="right"
            >
              <SortBy
                title={formatMessage({ id: 'dbi_store_rank_most_played' })}
                isNoDropdown={true}
                svgIcon={xbox}
              />
            </CloumsCenter>
          ),
          width: 300,
          render: (cvm: any) => (
            <div className="">
              <CloumsCenter
                width={160}
                style={{ marginLeft: '-40px' }}
                align="right"
              >
                <TableShowData
                  type={
                    cvm['xboxPlayChange'] > 0
                      ? 'up'
                      : cvm['xboxPlayChange'] < 0
                      ? 'down'
                      : ''
                  }
                  growth={
                    cvm['xboxPlayChange'] == 0
                      ? '-'
                      : Math.abs(cvm['xboxPlayChange'])
                  }
                  value={cvm['xboxPlay'] != 0 ? '#' + cvm['xboxPlay'] : '-'}
                />
              </CloumsCenter>

              {cvm['xboxPlayTips']?.length > 0
                ? cvm['xboxPlayTips']?.map((obj: any) => {
                    return <TabComponents data={RanderTipsData(obj)} />;
                  })
                : null}
            </div>
          ),
        },
        {
          key: 'xboxNew',
          align: 'center',
          header: (
            <CloumsCenter
              width={160}
              style={{ marginLeft: '-40px' }}
              align="right"
            >
              <SortBy
                title={formatMessage({ id: 'dbi_store_rank_new_release' })}
                isNoDropdown={true}
                svgIcon={xbox}
              />
            </CloumsCenter>
          ),
          width: 300,
          render: (cvm: any) => (
            <div className="">
              <CloumsCenter
                width={160}
                style={{ marginLeft: '-40px' }}
                align="right"
              >
                <TableShowData
                  type={
                    cvm['xboxNewChange'] > 0
                      ? 'up'
                      : cvm['xboxNewChange'] < 0
                      ? 'down'
                      : ''
                  }
                  growth={
                    cvm['xboxNewChange'] == 0
                      ? '-'
                      : Math.abs(cvm['xboxNewChange'])
                  }
                  value={cvm['xboxNew'] != 0 ? '#' + cvm['xboxNew'] : '-'}
                />
              </CloumsCenter>

              {cvm['xboxNewTips']?.length > 0
                ? cvm['xboxNewTips']?.map((obj: any) => {
                    return <TabComponents data={RanderTipsData(obj)} />;
                  })
                : null}
            </div>
          ),
        },
      ];
    }
    setTableColumn(columns);
  };

  const RanderTipsData = (tip: any) => {
    return {
      text:
        tip.indexOf('Dominate') != -1
          ? '7 Days'
          : tip.indexOf('New') != -1
          ? 'New'
          : 'Remained',
      color:
        tip.indexOf('Dominate') != -1
          ? '#EDA53A'
          : tip.indexOf('New') != -1
          ? '#0abf5b'
          : '#326FF0',
      conext: (
        <div style={{ whiteSpace: 'pre-wrap' }}>
          {tip.indexOf('Dominate') != -1
            ? 'Remained on the Big Riser at least 7 Days.\r\nBig Riser 霸榜至少7天'
            : tip.indexOf('New') != -1
            ? 'New game to the Big Riser.\r\n首次进入Big Riser榜单'
            : 'Remained on the Big Riser at least 2 Days.\r\nBig Riser 霸榜至少2天'}
        </div>
      ),
    };
  };

  return (
    <CardSlot
      className="tabdetails-top"
      iconList={null}
      title={
        <div className="tabdetails-gamehead">
          <div className="tabdetails-gamehead-title">
            <span>{title}</span>
            <TipContext
              className="icon-top"
              tipText={
                gameType == 'mobile'
                  ? formatMessage({ id: 'dbi_market_big_riser_tips_mobile' })
                  : gameType == 'pc'
                  ? formatMessage({ id: 'dbi_market_big_riser_tips_pc' })
                  : gameType == 'console'
                  ? formatMessage({ id: 'dbi_market_big_riser_tips_console' })
                  : null
              }
            />
          </div>
          <div className="tabdetails-gamehead-text">{time}</div>
        </div>
      }
    >
      {riserLoad ? (
        <div style={{ height: 200 }}>
          <Loading content={formatMessage({ id: 'common_loading' })} />
        </div>
      ) : data && data.length > 0 ? (
        <Table
          className="dbi-insights-table "
          records={data}
          bordered="all"
          columns={[...tableColumn]}
          addons={[
            pageable(),
            scrollable({
              minWidth: 1200,
            }),
          ]}
        />
      ) : (
        <div style={{ height: 200 }}>
          <NoData title="No trends data under current selections." />
        </div>
      )}
    </CardSlot>
  );
}
